import { FormattedMessage } from 'react-intl';
import Coupon from '@alltrails/core/types/Coupon';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import { getDiscountPercentage } from '@alltrails/payment/utils/plan';
import type Plans from '@alltrails/types/Plans';

const getCtaText = ({
  tierSelected,
  plans,
  coupon,
  isPeakPromoEligible,
  isPlusPromoEligible
}: {
  tierSelected: PurchaseTier;
  plans: Plans;
  coupon?: Coupon;
  isPeakPromoEligible?: boolean;
  isPlusPromoEligible?: boolean;
}) => {
  if (coupon?.type === 'FreeTrialCoupon') {
    return <FormattedMessage defaultMessage="Start your free trial" />;
  }

  if (coupon?.type === 'SubscriptionCoupon') {
    if (coupon.subscriptionTier === 'any' && coupon.discountPercentage) {
      const percent = coupon.discountPercentage / 100;
      return (
        <FormattedMessage
          defaultMessage="Save {percent, number, ::percent} on {tier}"
          values={{ percent, tier: tierSelected === 'plus' ? 'Plus' : 'Peak' }}
        />
      );
    }

    if (tierSelected === 'plus' && coupon?.subscriptionTier === 'plus') {
      const percent = getDiscountPercentage(plans.plus, coupon) / 100;
      return (
        <FormattedMessage
          defaultMessage="Save {percent, number, ::percent} on Plus"
          values={{
            percent
          }}
        />
      );
    }

    if (tierSelected === 'peak' && coupon?.subscriptionTier === 'peak') {
      const percent = getDiscountPercentage(plans.peak, coupon) / 100;
      return (
        <FormattedMessage
          defaultMessage="Save {percent, number, ::percent} on Peak"
          values={{
            percent
          }}
        />
      );
    }
  }

  if ((tierSelected === 'peak' && isPeakPromoEligible) || (tierSelected === 'plus' && isPlusPromoEligible)) {
    return <FormattedMessage defaultMessage="Start your free trial" />;
  }

  if (tierSelected === 'peak') {
    return <FormattedMessage defaultMessage="Continue with Peak" />;
  }

  return <FormattedMessage defaultMessage="Continue with Plus" />;
};

export default getCtaText;
